module.exports = __webpack_public_path__ + "src/assets/img/m40.cdb8a22b.svg";